(function () {
  const bar = document.querySelector('[data-sticky-atc]');
  if (!bar) return;
  const mainAtc = document.querySelector('paragraph-atc') || document.querySelector('product-form');
  if (!mainAtc) return;

  let drawerOpen = false;
  const drawer = document.querySelector('cart-drawer');
  if (drawer) {
    const mo = new MutationObserver(() => {
      drawerOpen = drawer.classList.contains('active') || drawer.hasAttribute('open');
      if (drawerOpen) bar.dataset.hidden = 'true';
      else delete bar.dataset.hidden;
    });
    mo.observe(drawer, { attributes: true, attributeFilter: ['class', 'open'] });
  }

  const io = new IntersectionObserver((entries) => {
    const entry = entries[0];
    if (drawerOpen) return;
    if (!entry.isIntersecting) {
      bar.setAttribute('data-visible', 'true');
      bar.setAttribute('aria-hidden', 'false');
    } else {
      bar.removeAttribute('data-visible');
      bar.setAttribute('aria-hidden', 'true');
    }
  }, { threshold: 0 });
  io.observe(mainAtc);
})();
